(ns app.survey.processing)

(defn view
  []
  [:div
   {:class-name "p-6 flex justify-center"}
   "Processing"])
